import { Option as OptionType } from 'shop/types/cart'
import { ModifierOptionGroupName } from '../commonStyles'
import styled from '@emotion/styled'
import Option from './Option'

interface Props {
  options: OptionType[]
}

const OptionList = ({ options }: Props) => {
  const allOptions = options.flatMap(({ values }) => values)

  return (
    <Content data-testid='options'>
      <ModifierOptionGroupName>
        <Option values={allOptions} />
      </ModifierOptionGroupName>
    </Content>
  )
}

const Content = styled.div(() => ({
  whiteSpace: 'pre'
}))

export default OptionList
